import type { GetterTree } from 'vuex'
import type { ServiceHealthStatus } from '@/types/admin'
import type { RootState } from '@/store'
import type { AdminPanelState, AdminPanelAccountRow, ServiceKey } from './types'
import { ADMIN_PANEL_GETTERS } from './types'

interface IAdminPanelGetters extends GetterTree<AdminPanelState, RootState> {
  [ADMIN_PANEL_GETTERS.GET_ACCOUNTS_TABLE_DATA](state: AdminPanelState): AdminPanelAccountRow[]
  [ADMIN_PANEL_GETTERS.GET_SERVICE_STATUS](
    state: AdminPanelState
  ): (key: ServiceKey) => ServiceHealthStatus | null
}

const getters: IAdminPanelGetters = {
  [ADMIN_PANEL_GETTERS.GET_ACCOUNTS_TABLE_DATA](state) {
    return state.accounts
  },
  [ADMIN_PANEL_GETTERS.GET_SERVICE_STATUS](state) {
    return (key: ServiceKey) => state.serviceStatuses[key]
  }
}

export default getters
